import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const Home = () => {
  const navigate = useNavigate();
  let [urlSearchParams] = useSearchParams();

  React.useEffect(() => {
    //   const navigate = useNavigate();
    const docType = urlSearchParams.get("docType");
    // if (docType) {
    //   navigate(`/upload?docType=${docType}`);
    // } else {
    //   navigate(`/upload?docType=notype`);
    // }
    setTimeout(function() {
      navigate("/hints");
    }, 3000)

  }, []);

  // return <>loading ..</>;
    return (
        <div className="flex flex-col ">
            <div className="flex-grow flex flex-col items-center justify-center px-6">
              <h2 className="text-2xl mt-8">Make the perfect ID-photo</h2>
            </div>
        </div>
    )
};
